/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetManyBaseAodRunsControllerAodRunQueryResponse, GetManyBaseAodRunsControllerAodRunQueryParams } from "../models/GetManyBaseAodRunsControllerAodRun";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getManyBaseAodRunsControllerAodRun } from "../axios/getManyBaseAodRunsControllerAodRun";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getManyBaseAodRunsControllerAodRunQueryKey = (params: GetManyBaseAodRunsControllerAodRunQueryParams = {}) => ["audit-reports-api", { url: '/aod-runs' }, ...(params ? [params] : [])] as const

export type GetManyBaseAodRunsControllerAodRunQueryKey = ReturnType<typeof getManyBaseAodRunsControllerAodRunQueryKey>

export function getManyBaseAodRunsControllerAodRunQueryOptions(params?: GetManyBaseAodRunsControllerAodRunQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getManyBaseAodRunsControllerAodRunQueryKey(params)
        return queryOptions<GetManyBaseAodRunsControllerAodRunQueryResponse, ResponseErrorConfig<Error>, GetManyBaseAodRunsControllerAodRunQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getManyBaseAodRunsControllerAodRun(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve multiple AodRuns
 * {@link /aod-runs}
 */
export function useGetManyBaseAodRunsControllerAodRun<TData = GetManyBaseAodRunsControllerAodRunQueryResponse, TQueryData = GetManyBaseAodRunsControllerAodRunQueryResponse, TQueryKey extends QueryKey = GetManyBaseAodRunsControllerAodRunQueryKey>(params?: GetManyBaseAodRunsControllerAodRunQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetManyBaseAodRunsControllerAodRunQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getManyBaseAodRunsControllerAodRunQueryKey(params)
         

         const query = useQuery({
          ...getManyBaseAodRunsControllerAodRunQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}